import { Script } from "gatsby";
import React from "react";

import { navItems } from "components/Nav";

export const formatPageTitle = (title?: string) => {
  if (!title) {
    return process.env.GATSBY_SITE_NAME;
  }
  return `${title} | ${process.env.GATSBY_SITE_NAME}`;
};

export const analytics = () => (
  <>
    <Script
      async
      src={`https://www.googletagmanager.com/gtag/js?id=${process.env.GATSBY_MEASUREMENT_ID}`}
    />
    <Script id="google-analytics" strategy="post-hydrate">
      {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){window.dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${process.env.GATSBY_MEASUREMENT_ID}');
        `}
    </Script>
    <Script id="clarity-analytics" strategy="post-hydrate">
      {`
          (function(c,l,a,r,i,t,y){
            c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
            t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
            y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
        })(window, document, "clarity", "script", '${process.env.GATSBY_CLARITY_ID}');
        `}
    </Script>
    {/* <Script src="/utils/ga.js" />
    <Script src="/utils/clarity.js" /> */}
    <Script
      id="hs-script-loader"
      async
      defer
      src="//js.hs-scripts.com/39824213.js"
    ></Script>
  </>
);

export const getPageMetaFromUrl = (pageUrl?: string) => {
  if (!pageUrl) {
    return <title>{`${process.env.GATSBY_SITE_NAME}`}</title>;
  }

  const flatNavItems = navItems.reduce(
    (acc, item) => {
      return acc?.concat(item.children || [], item);
    },
    [] as (typeof navItems)[0]["children"],
  );

  const { description, title, url } =
    flatNavItems?.find((item) => item.url === pageUrl) || {};

  let parentUrl: string | undefined = undefined;
  let parentTitle = undefined;

  if (url) {
    parentUrl = url.split("/").slice(0, -1).join("/");
    parentTitle = flatNavItems?.find((item) => item.url === parentUrl)?.title;
  }

  return (
    <>
      {analytics()}
      <title>
        {formatPageTitle(`${parentTitle ? `${parentTitle} - ` : ""}${title}`)}
      </title>
      <meta name="description" content={description} />
    </>
  );
};
